import { SignupFormData } from './types'

export type SignupFormErrors = Partial<Record<(keyof SignupFormData) | 'terms', string>>

export const validateForm = (formData: Partial<SignupFormData>): SignupFormErrors => {
  const errors: SignupFormErrors = {}

  if (!formData.email) {
    errors.email = 'Email is required'
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = 'Email is invalid'
  }


  if (!formData.firstName) {
    errors.firstName = 'First name is required'
  }

  if (!formData.lastName) {
    errors.lastName = 'Last name is required'
  }

  if (!formData.password) {
    errors.password = 'Password is required'
  } else if (formData.password.length < 8) {
    errors.password = 'Password must be at least 8 characters'
  }

  if (!formData.confirmPassword) {
    errors.confirmPassword = 'Please confirm your password'
  } else if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = 'Passwords do not match'
  }

  if (!formData.terms) {
    errors.terms = 'You must agree to the terms and privacy policy'
  }

  return errors
} 